export const AuthEndpoints = {
  refreshToken: '/auth/refresh-token',
  logout: '/auth/logout',
  login: '/auth/login',
  forgotPassword: '/auth/forgot-password',
  googleLogin: '/auth/google',
  resetPassword: '/auth/reset-password',
};
